import { render, staticRenderFns } from "./adminIndex.vue?vue&type=template&id=7a2c8c06&"
import script from "./adminIndex.vue?vue&type=script&lang=js&"
export * from "./adminIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports